import { render, staticRenderFns } from "./overview-admin.vue?vue&type=template&id=46497ba7&scoped=true"
import script from "./overview-admin.vue?vue&type=script&lang=js"
export * from "./overview-admin.vue?vue&type=script&lang=js"
import style0 from "./overview-admin.vue?vue&type=style&index=0&id=46497ba7&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46497ba7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/LRL_LCDDMAC_eMSL_CFC/LRL_LCDDMAC_eMSL_CFC/Frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('46497ba7')) {
      api.createRecord('46497ba7', component.options)
    } else {
      api.reload('46497ba7', component.options)
    }
    module.hot.accept("./overview-admin.vue?vue&type=template&id=46497ba7&scoped=true", function () {
      api.rerender('46497ba7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/overview/overview-admin.vue"
export default component.exports